import React from 'react';
import './Certificates.css';

const certificates = [
  {
    title: 'Fighters of Fire M/C 2024',
    imgName: 'FightersOfFire2024.jpg',
  },

  {
    title: 'Knights on BIkes 2022 Food Drive',
    imgName: 'Thank You Knights on BIkes 6-9-2022.jpg',
  },
  { title: 'NYFAC Autism 2022', imgName: 'Thank You NYFAC 2022 paint.jpg' },
  {
    title: 'American Legion Riders 2021',
    imgName: 'Thank You American Legion Riders 2021-P.jpg',
  },
  {
    title: '2019 Firefighters Wounded Warrior Fund Raiser',
    imgName: 'Thankyou Wounded Warrior 2019-P.jpg',
  },
  { title: 'Girl Scouts', imgName: 'Girl Scouts 2018 copy.jpg' },
  { title: 'NYFAC Autism 2018', imgName: 'THANK OU NYFAC Autism 2018 .jpg' },
  {
    title: 'Rocking the Road for a Cure',
    imgName: 'THANK YOU 2017 Rocking the Road for a Cure.jpg',
  },
  {
    title: 'American Legion 2017',
    imgName: 'Thank you American Legion 2017.jpg',
  },
  { title: 'NYFAC Autism', imgName: 'Thank You NYFAC Autism.jpg' },
  {
    title: '2012 MDA Support Letter',
    imgName: 'Thankyou 2012 MDA support leter.jpg',
  },
  {
    title: '2012 American Spirit',
    imgName: 'Thankyou 2012 American Spirit run support leter.jpg',
  },
  {
    title: '2011 American Spirit',
    imgName: 'THANK YOU 2011 American Spirit Tombstone Run.jpg',
  },
  { title: '2009 Crushers', imgName: 'Thank you 2009 Crushers MC..jpg' },
  {
    title: '2008 NY Titans Baseball',
    imgName: 'Thankyou 2008 NY Titans Baseball.jpg',
  },
  {
    title: '2008 Edwin Earle Car Show',
    imgName: 'Thankyou 2008 Edwin Earle Car Show.jpg',
  },
  {
    title: '2008 American Spirit',
    imgName: 'Thankyou 2008 American Spirit.jpg',
  },
  { title: '2007 Sinful Souls', imgName: 'Thankyou 2007 Sinful Souls MC.jpg' },
  {
    title: '2007 Edwin Earle Car Show',
    imgName: '2007Thankyou  edwin earle car show.jpg',
  },
  {
    title: '2006 SALUTE THE VETS NAM KNIGHTS',
    imgName:
      '2006  THANK YOU NYC SALUTES THE VETS NAM KNIGHTS OF AMERICA M.jpg',
  },
  {
    title: '2006 Edwin Earle Car Show',
    imgName: '2006 Thankyou Edwin Earle Car Show.jpg',
  },
  {
    title: '2005 NCCC Businessperson of the Year',
    imgName: '2005 Thankyou NCCC Businessperson of the year.jpg',
  },
  {
    title: '2005 Edwin Earle Car Show',
    imgName: '2005 Thankyou Edwin Earle Car Show.jpg',
  },
  {
    title: '2005 Brooklyn Nam Knights',
    imgName: '2005 Thankyou Brooklyn Nam Knights MC.jpg',
  },
  {
    title: '2004 Sarah Grace Foundation',
    imgName: '2004 Thankyou Sarah Grace Foundation.jpg',
  },
  { title: '2004 Marines', imgName: '2004 Thankyou Marines.jpg' },
  {
    title: '2004 Iron Madien',
    imgName: '2004 Thankyou Iron Madien Itsy Bitsy Spider Run.jpg',
  },
  {
    title: '2004 Lupus Alliance of America',
    imgName: '2004 Thankyou Lupus Alliance of America2.jpg',
  },
  {
    title: '2004 Brooklyn Nam Knights',
    imgName: '2004 Thankyou Brooklyn Nam Knights MC2.jpg',
  },
  {
    title: '2004 Boces Carman Road School',
    imgName: '2004 Thankyou Boces Carman Road School inside.jpg',
  },
  {
    title: '2004 American Spirit',
    imgName: '2004 Thankyou American Spirit.jpg',
  },
  {
    title: '2003 Iron Maidens',
    imgName: '2003 Thank You ITSY BITSY SPIDER RUN IRON MAIDENS.jpg',
  },
  {
    title: '2003 RANDY BYNOE MEMORIAL SOUTH SHORE M/C',
    imgName: '2003 THANK YOU RANDY BYNOE MEMORIAL SOUTH SHORE MC.jpg',
  },
  {
    title: '2003 Hempstead Police',
    imgName: '2003 Thankyou Hempstead Police Golf Classic.jpg',
  },
  {
    title: '2002 Fathers Day Car Show',
    imgName: '2002 THANK YOU FATHERS DAY CAR SHOW 1.jpg',
  },
  {
    title: '2002 Thomas Mannle Memorial Run Fireriders M/C',
    imgName: '2002 THANK YOU THOMAS MANNLE MEMORIAL RUN FIRERIDERS MC.jpg',
  },
  {
    title: '2002 Hempstead Police Golf Classic',
    imgName: '2002 Thankyou Hempstead Police Golf Classic.jpg',
  },
  { title: '2002 AMA', imgName: '2002 Thankyou AMA.jpg' },
  {
    title: '2001 Iron Maidens',
    imgName: '2001 Thankyou Iron Maidens Itsy Bitsy Spider Run.jpg',
  },
  { title: '2001 AMA', imgName: '2001 Thankyou AMA.jpg' },
  { title: '2000 AMA.', imgName: '2000 Thankyou AMA.jpg' },
  { title: '2000 Nassau Wings', imgName: '2000 THANK YOU NASSAU WINGS MC.jpg' },
  {
    title: '1999 CASINO RUN QUEENSBORO M/C',
    imgName: '1999 THANK YOU CASINO RUN QUEENSBORO MC.jpg',
  },
  { title: '1999 Toys for tots', imgName: '1999 Thankyou Toys for tots.jpg' },
  { title: '1999 AMA.', imgName: '1999 Thankyou AMA.jpg' },
  {
    title: '1998 Casion Run Queensboro M/C',
    imgName: '1998 THANK YOU 1998 CASINO RUN QUEENSBORO MC.jpg',
  },
  {
    title: '1996 Hempstead Police',
    imgName: '1996 Thankyou Hempstead Police Golf Classic.jpg',
  },
  {
    title: '1996 Casino Run Queensboro M/C',
    imgName: '1996 Thankyou Casino Run Queensboro MC.jpg',
  },
  {
    title: '1995 Chrome Specialties',
    imgName: '1995 Thankyou Chrome Specialties.jpg',
  },
  { title: 'AMA District 34', imgName: '1995 AMA District 34.jpg' },
  {
    title: '1994 Hempstead Police',
    imgName: '1994 Thankyou -Hempstead-Pol.jpg',
  },
  {
    title: '1993 United Cerebral Palsy Assoc.',
    imgName: '1993 Thankyou United Cerebral Palsy Assoc.jpg',
  },
  {
    title: '1993 Casino Run Queensboro M/C',
    imgName: '1993 Thankyou Casino Run Queensboro MC.jpg',
  },
  {
    title: '1991 Independent Bikers Toys for Tots',
    imgName: '1991 Thankyou Independent Bikers Toys for Tots.jpg',
  },
  { title: '1986 Custom Chrome', imgName: '1986 Thankyou Custom Chrome.jpg' },
  {
    title: '1983 Freeport Speedway 17 Frankie A.',
    imgName: '1983 Thankyou 17 Frank.jpg',
  },
];

export default function Certificates() {
  const handleImageClick = (cert) => {
    const imgPath = `/Assets/Certificates/${
      cert.imgName || cert.title.replace(/\s+/g, '')
    }`;
    window.open(imgPath, '_blank');
  };

  return (
    <div className="certificates-container">
      <h1>Our Certifications</h1>
      <p className="certificates-intro">
        Rolling Thunder Cycles is proud to support our community and various
        charitable organizations. Over the years, we have received numerous
        certificates of appreciation for our contributions. Below is a gallery
        of some of the certificates we have received, showcasing our commitment
        to making a positive impact. Click on any certificate to view it in
        full.
      </p>
      <div className="certificates-gallery">
        {certificates.map((cert, idx) => (
          <div className="certificate-card" key={idx}>
            <img
              src={`/Assets/Certificates/${
                cert.imgName || cert.title.replace(/\s+/g, '')
              }`}
              alt={cert.title}
              className="certificate-img"
              onClick={() => handleImageClick(cert)}
              style={{ cursor: 'pointer' }}
            />
            <div className="certificate-title">{cert.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
